// 長いボタン中央寄せ用棚
import React from 'react';
import { Row, Col } from 'react-bootstrap';

const RowCenterLongButton: React.FC = ({ children }) => {
  return (
    <Row className="row-center-long-button">
      <Col className="text-center">{children}</Col>
    </Row>
  );
};

export default RowCenterLongButton;
